// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__uPP5t","crumb":"breadcrumbs_crumb__FUNf0","current":"breadcrumbs_current__+FgB5","sep":"breadcrumbs_sep__KsdZh"};